/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-12-15 14:30:43
 */
import ColumnTypes from "@/utils/ColumnTypes";

const myActivities = {
    key: 'myActivities',
    label: '商品信息',
    type: ColumnTypes.channelShopCell,
    minWidth: '400',
    fixed: 'left'
};
const item_name = {
    key: 'item_name',
    label: '合作方信息',
    copy_id: 'item_id',
    notes: '店铺/机构ID',
    type: ColumnTypes.cooperationInfoCell,
    minWidth: '160'
}
const extension_time = {
    key: 'extension_time',
    label: '推广时间',
    minWidth: '150',
    startTime: 'promotion_start_time',
    endTime: 'promotion_end_time',
    type: ColumnTypes.extensionTimeCell,
}
const service_rate = {
    key: 'service_rate',
    label: '服务费率',
    type: ColumnTypes.serviceRateCell,
    isShow: true,
    minWidth: '120'
}
const commission_rate = {
    key: 'commission_rate',
    label: '佣金率',
    type: ColumnTypes.commissionRateCell,
    isShow: true,
    minWidth: '100'
}
const operations = {
    key: 'operations',
    label: '操作',
    minWidth: '80',
    fixed: 'right',
    type: ColumnTypes.ButtonsCell,
    align: 'right'
}

export const columns = [
    myActivities,
    item_name,
    extension_time,
    service_rate,
    commission_rate,
    operations
]